import { Screen } from '~/screens/StressAssessments/[id]/reportsDownload';

export const StressAssessmentsReportsDownload: React.FC = () => {
  return <Screen />;
};
